

export default class InvestigationInteractor {
  constructor(dataService, coachGateway) {
    this.dataService = dataService;
    this.coachGateway = coachGateway;
  }

  getInvestigations() {
    return this.coachGateway.investigations(this.dataService.secretKey)
      .then(response => response.investigations);
  }

  withReceivedInvestigations() {
    return this.coachGateway.getReceivedInvestigations(this.dataService.secretKey)
      .then(response => {
        this.receivedInvestigations = response.questionnaire_instances;
      });
  }

  lockInvestigation(investigation) {
    return this.coachGateway.lockInvestigation(this.dataService.secretKey, investigation.id)
      .then(() => investigation.is_open = false);
  }

  openReports(investigation) {
    return this.coachGateway.setReportAvailability(this.dataService.secretKey, investigation.id, true);
  }

  closeReports(investigation) {
    return this.coachGateway.setReportAvailability(this.dataService.secretKey, investigation.id, false);
  }

  getInvestigation(id) {
    return this.coachGateway.getInvestigation(this.dataService.secretKey, id);
  }

  archiveInvestigation(investigation) {
    return this.coachGateway.archiveInvestigation(this.dataService.secretKey, investigation.id)
      .then(() => investigation.is_archived = true);
  }
}